import * as React from "react";
import { m, type HTMLMotionProps } from "framer-motion";

/**
 * LazyMotion の `m.div` / `m.span` は、React 18 の型定義と組み合わせると
 * `HTMLMotionProps` が正しく展開されず `className` や `ref` が拒否されることがある。
 * 実行時のコンポーネントは `m` と同一なので、DOM 属性を明示した型だけ付け替える。
 */
type MotionDivProps = HTMLMotionProps<"div"> & {
  className?: string;
};

type MotionSpanProps = HTMLMotionProps<"span"> & {
  className?: string;
};

export const MotionDiv = m.div as unknown as React.ForwardRefExoticComponent<
  React.PropsWithoutRef<MotionDivProps> & React.RefAttributes<HTMLDivElement>
>;

export const MotionSpan = m.span as unknown as React.ForwardRefExoticComponent<
  React.PropsWithoutRef<MotionSpanProps> & React.RefAttributes<HTMLSpanElement>
>;
